<template>
  <div class="zskt-page">
    <div class="overlay"></div>
    <Header />
    
    <main class="main-content">
      <section class="page-title">
        <div class="container">
          <h1>知识课堂</h1>
          <div class="breadcrumb">
            <router-link to="/">首页</router-link>
            <span class="separator">/</span>
            <span class="current">知识课堂</span>
          </div>
        </div>
      </section>

      <section class="filter-section">
        <div class="container">
          <div class="filter-wrapper">
            <div class="filter-group">
              <span class="filter-label">课程分类：</span>
              <div class="filter-options">
                <a href="#" :class="{ active: activeCategory === 'all' }" @click.prevent="setCategory('all')">全部</a>
                <a href="#" v-for="category in categories" :key="category" 
                   :class="{ active: activeCategory === category }"
                   @click.prevent="setCategory(category)">
                  {{ category }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="course-list">
        <div class="container">
          <div class="course-grid">
            <article class="course-card" v-for="course in filteredCourses" :key="course.id" data-aos="fade-up">
              <div class="course-image">
                <img :src="require(`@/assets/images/${course.image}`)" :alt="course.title">
                <div class="course-level">{{ course.level }}</div>
              </div>
              <div class="course-content">
                <div class="course-tags">
                  <span class="tag">{{ course.category }}</span>
                  <span class="duration"><i class="far fa-clock"></i> {{ course.duration }}</span>
                </div>
                <h3 class="course-title">{{ course.title }}</h3>
                <p class="course-desc">{{ course.description }}</p>
                <div class="course-meta">
                  <span class="views"><i class="far fa-eye"></i> {{ course.views }}</span>
                  <span class="likes"><i class="far fa-heart"></i> {{ course.likes }}</span>
                  <router-link :to="{ name: 'ZsktList', params: { id: course.id } }" class="btn-learn">开始学习</router-link>
                </div>
              </div>
            </article>
          </div>

          <div class="pagination">
            <a href="#" class="active">1</a>
            <a href="#">2</a>
            <a href="#">3</a>
            <span class="dots">...</span>
            <a href="#">10</a>
            <a href="#" class="next">下一页 <i class="fas fa-angle-right"></i></a>
          </div>
        </div>
      </section>
    </main>
    
    <Footer />
    <SideService />
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import SideService from '@/components/SideService.vue';

export default {
  name: 'Zskt',
  components: {
    Header,
    Footer,
    SideService
  },
  data() {
    return {
      activeCategory: 'all',
      categories: ['ERP基础', '生产管理', '库存管理', '采购管理', '质量管控', '数据分析'],
      courses: [
        {
          id: 1,
          image: 'xtrmjc.jpg',
          level: '入门',
          category: 'ERP基础',
          duration: '30分钟',
          title: 'ERP系统基础入门指南',
          description: '了解ERP系统的基本概念、核心模块及其在企业中的应用价值。',
          views: 2345,
          likes: 168
        },
        {
          id: 2,
          image: 'scglkc.jpg',
          level: '进阶',
          category: '生产管理',
          duration: '45分钟',
          title: '生产计划与排程优化技巧',
          description: '深入学习生产计划制定方法，掌握先进排程技术，提升生产效率。',
          views: 1892,
          likes: 145
        },
        {
          id: 3,
          image: 'kcglkc.jpg',
          level: '高级',
          category: '库存管理',
          duration: '60分钟',
          title: '智能库存预测与控制',
          description: '运用数据分析方法，实现精准的库存预测和智能化库存控制。',
          views: 1567,
          likes: 132
        },
        {
          id: 4,
          image: 'cggl.jpg',
          level: '高级',
          category: '采购管理',
          duration: '60分钟',
          title: '采购管理迎数字化变革',
          description: '全流程优化与全球化采购成降本增效新引擎',
          views: 1567,
          likes: 132
        }
      ]
    }
  },
  computed: {
    filteredCourses() {
      if (this.activeCategory === 'all') {
        return this.courses;
      }
      return this.courses.filter(course => course.category === this.activeCategory);
    }
  },
  methods: {
    setCategory(category) {
      this.activeCategory = category;
    }
  },
  mounted() {
    // 初始化AOS动画库
    if (typeof AOS !== 'undefined') {
      AOS.init({
        duration: 1000,
        once: true
      });
    }
  }
}
</script>

<style scoped>
Function.vue还有一些显示上的问题，可以参照function.html
 整体的颜色不对，不是蓝色，主题颜色应该为：    --primary-color：#009b7b
1 管简单一体化全功能一览 内容缺失和展现样式也不对
2 多个环境下，随时随地管理车间现场缺失
3  客户证言  缺失:root {
  --primary-color: #009b7b;
  --secondary-color: #007a61;
}

/* 页面标题区域 */
.page-title {
  background: url('@/assets/images/banner.jpg') center/cover;
  color: #fff;
  padding: 140px 0;
  position: relative;
  overflow: hidden;
}

.page-title::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('@/assets/images/banner.jpg') center/cover;
  opacity: 0.1;
  z-index: 1;
}

.page-title .container {
  position: relative;
  z-index: 2;
}

.page-title h1 {
  font-size: 2.5rem;
  margin: 0 0 15px;
  font-weight: 600;
}

.breadcrumb {
  display: flex;
  align-items: center;
  gap: 10px;
  color: rgba(255, 255, 255, 0.8);
}

.breadcrumb a {
  color: #fff;
  text-decoration: none;
  transition: color 0.3s;
}

.breadcrumb a:hover {
  color: #4cd4bc;
}

.breadcrumb .separator {
  color: rgba(255, 255, 255, 0.5);
}

/* 筛选区域 */
.filter-section {
  background: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 20px 0;
  position: sticky;
  top: 0;
  z-index: 100;
}

.filter-wrapper {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.filter-group {
  display: flex;
  align-items: center;
  gap: 15px;
}

.filter-label {
  color: #333;
  font-weight: 500;
  min-width: 80px;
}

.filter-options {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.filter-options a {
  text-decoration: none;
  color: #666;
  padding: 6px 15px;
  border-radius: 20px;
  background: #f5f5f5;
  transition: all 0.3s;
}

.filter-options a:hover {
  background: #e5f4f1;
  color: var(--primary-color);
}

.filter-options a.active {
  background: var(--primary-color);
  color: #fff;
  box-shadow: 0 4px 15px rgba(0, 155, 123, 0.2);
}

/* 课程列表区域 */
.course-list {
  padding: 40px 0;
  background: #f8f9fa;
}

.course-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 30px;
  margin-bottom: 40px;
}

.course-card {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 155, 123, 0.08);
  transition: all 0.3s ease;
  border: 1px solid rgba(0, 155, 123, 0.05);
}

.course-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 155, 123, 0.15);
  border-color: rgba(0, 155, 123, 0.1);
}

.course-image {
  position: relative;
  padding-top: 60%; /* 16:9 比例 */
  overflow: hidden;
}

.course-image img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s;
}

.course-card:hover .course-image img {
  transform: scale(1.05);
}

.course-level {
  position: absolute;
  top: 15px;
  right: 15px;
  background: linear-gradient(135deg, rgba(26, 115, 232, 0.7), rgba(0, 155, 123, 0.7));
  color: #fff;
  padding: 4px 12px;
  border-radius: 15px;
  font-size: 0.875rem;
}

.course-content {
  padding: 20px;
}

.course-tags {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.tag {
  background: #e5f4f1;
  color: var(--primary-color);
  padding: 4px 12px;
  border-radius: 15px;
  font-size: 0.875rem;
  transition: all 0.3s ease;
}

.tag:hover {
  background: var(--primary-color);
  color: #fff;
  box-shadow: 0 4px 15px rgba(0, 155, 123, 0.2);
}

.duration {
  color: #666;
  font-size: 0.875rem;
}

.duration i {
  margin-right: 5px;
}

.course-title {
  font-size: 1.25rem;
  margin: 0 0 10px;
  color: #333;
  line-height: 1.4;
}

.course-desc {
  color: #666;
  font-size: 0.875rem;
  margin-bottom: 20px;
  line-height: 1.6;
}

.course-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 15px;
  border-top: 1px solid #eee;
}

.views, .likes {
  color: #666;
  font-size: 0.875rem;
}

.views i, .likes i {
  margin-right: 5px;
}

.btn-learn {
  background: var(--primary-color);
  color: #fff;
  padding: 8px 20px;
  border-radius: 20px;
  text-decoration: none;
  font-size: 0.875rem;
  transition: all 0.3s ease;
  border: 1px solid transparent;
}

.btn-learn:hover {
  background: var(--secondary-color);
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0, 155, 123, 0.2);
}

/* 分页导航 */
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  margin: 3rem 0 4rem 0;
  padding-bottom: 2rem;
}

.pagination a, .pagination span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  height: 40px;
  padding: 0 15px;
  border-radius: 20px;
  background: #fff;
  color: #333;
  text-decoration: none;
  transition: all 0.3s;
}

.pagination a:hover {
  background: #e5f4f1;
  color: var(--primary-color);
}

.pagination a.active {
  background: var(--primary-color);
  color: #fff;
  box-shadow: 0 4px 15px rgba(0, 155, 123, 0.2);
}

.pagination .dots {
  color: #666;
}

.pagination .next i {
  margin-left: 5px;
}

/* 响应式适配 */
@media (max-width: 1200px) {
  .course-grid {
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  }
}

@media (max-width: 992px) {
  .page-title {
    padding: 40px 0;
  }

  .page-title h1 {
    font-size: 2rem;
  }
}

@media (max-width: 768px) {
  .filter-group {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .filter-options {
    width: 100%;
  }

  .course-grid {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  }

  .pagination {
    flex-wrap: wrap;
  }
}

@media (max-width: 576px) {
  .page-title h1 {
    font-size: 1.75rem;
  }

  .course-grid {
    grid-template-columns: 1fr;
  }

  .course-card {
    max-width: 100%;
  }
}
</style>